import React from 'react';
import PropTypes from 'prop-types';
import Close from './Close';
import AlertMessage from './AlertMessage';
import AlertIcon from './AlertIcon';

export const Alert = props => {
  const { level, message, className, close, onClickClose } = props;

  return (
    <div className={`pxl-alert pxl-alert--${level} ${className}`}>
      <AlertIcon level={level} />
      <AlertMessage msg={message} />
      <Close onClick={onClickClose} close={close} />
    </div>
  );
};

Alert.propTypes = {
  className: PropTypes.string,
  close: PropTypes.bool,
  level: PropTypes.oneOf(['danger', 'info', 'success', 'warning']).isRequired,
  message: PropTypes.any.isRequired,
  onClickClose: PropTypes.func
};

Alert.defaultProps = {
  className: '',
  level: 'danger'
};

export default Alert;
